import * as React from "react";
import {FormBodyProps} from "../../common/props/FormBodyProps";
import SectionView from "../../layout/section/SectionView";
import InputFormGroup from "../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import CurrencyInputFormGroup from "../../ui/form/CurrencyInputFormGroup";
import AssetForm from "./form/AssetForm";
import Col from "../../layout/Col";
import Row from "../../layout/Row";
import SelectAssetCategoryFormGroup from "./form/SelectAssetCategoryFormGroup";
import CheckboxFormGroup from "../../ui/form/CheckboxFormGroup";
import AssetSpecificationFormGroup from "./form/AssetSpecificationFormGroup";
import TextAreaFormGroup from "../../ui/form/TextAreaFormGroup";
import RangeNumberInputFormGroup from "../../ui/form/RangeNumberInputFormGroup";
import TierLeverFormGroup from "./TierLeverFormGroup";
import KeywordsFormGroup from "../keywords/KeywordsFormGroup";
import PrimaryAndOtherFilesDropDown from "../../file/PrimaryAndOtherFilesDropDown";
import Attachment from "../../../model/attachment/Attachment";

interface ComponentProps {
	/**
	 * On add file
	 */
	onAddOrUpdateFile: (files: (File | Attachment)[]) => void;
}

type Props = FormBodyProps<AssetForm> & ComponentProps;

export default class AssetFormBody extends React.PureComponent<Props, {}> {
	render() {
		return (
			<SectionView>
				<div className={"c-asset-form-body"}>
					<Row>
						<Col xl={12} md={12}>
							<Row>
								<Col xl={6} md={6}>
									<InputFormGroup label="Manufacturer"
													placeholder="Enter manufacturer"
													field={this.props.form.manufacturer}
													onChange={this.props.onFieldChange}
													focus={this.props.form.hasFocus(this.props.form.manufacturer)}/>
								</Col>
								<Col xl={6} md={6}>
									<InputFormGroup label="Model"
													placeholder="Enter model"
													field={this.props.form.model}
													onChange={this.props.onFieldChange}
													focus={this.props.form.hasFocus(this.props.form.model)}/>
								</Col>
							</Row>
							<Row>
								<Col xl={6} md={6}>
									<SelectAssetCategoryFormGroup field={this.props.form.categoryId}
																  onChange={this.props.onFieldChange}
																  label={"Asset category"}
																  placeholder={"Select asset category"}/>
								</Col>
								<Col xl={6} md={6}>
									<InputFormGroup label="Type"
													placeholder="Enter type"
													field={this.props.form.type}
													onChange={this.props.onFieldChange}
													focus={this.props.form.hasFocus(this.props.form.type)}/>
								</Col>
							</Row>
							<Row>
								<Col xl={6} md={6}>
									<InputFormGroup label="First merchant code"
													placeholder="Enter first merchant code"
													field={this.props.form.firstMerchantCode}
													onChange={this.props.onFieldChange}
													focus={this.props.form.hasFocus(this.props.form.firstMerchantCode)}/>
								</Col>
								<Col xl={6} md={6}>
									<InputFormGroup label="Second merchant code"
													placeholder="Enter second merchant code"
													field={this.props.form.secondMerchantCode}
													onChange={this.props.onFieldChange}
													focus={this.props.form.hasFocus(this.props.form.secondMerchantCode)}/>
								</Col>
							</Row>
							<Row>
								<Col xl={6} md={6}>
									<CurrencyInputFormGroup field={this.props.form.price}
															placeholder={"Enter price"}
															onChange={this.props.onFieldChange}
															label={"Price (€)"}
															focus={this.props.form.hasFocus(this.props.form.price)}/>
								</Col>
								<Col xl={6} md={6}>
									<CurrencyInputFormGroup field={this.props.form.secondaryPrice}
															placeholder={"Enter secondary price"}
															onChange={this.props.onFieldChange}
															label={"Secondary price (€)"}
															focus={this.props.form.hasFocus(this.props.form.price)}/>
								</Col>
							</Row>
							<Row>
								<Col lg={6} xl={6}>
									<RangeNumberInputFormGroup field={this.props.form.markup}
															   minValue={0}
															   maxValue={100}
															   placeholder={"Enter markup"}
															   onChange={this.props.onFieldChange}
															   label={"Markup (%)"}
															   focus={this.props.form.hasFocus(this.props.form.markup)}/>
								</Col>
								<Col md={12} lg={6} xl={6}>
									<CurrencyInputFormGroup field={this.props.form.rebate}
															placeholder={"Enter rebate"}
															onChange={this.props.onFieldChange}
															label={"Rebate (€)"}
															focus={this.props.form.hasFocus(this.props.form.rebate)}/>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row>
						<Col xl={12} md={12}>
							<AssetSpecificationFormGroup label={"Specification"}
														 field={this.props.form.specifications}
														 onChange={this.props.onFieldChange}/>
						</Col>
					</Row>
					<Row>
						<Col lg={6} xl={6}>
							<InputFormGroup label={"Warranty code"}
											field={this.props.form.warrantyCode}
											onChange={this.props.onFieldChange}
											placeholder={"Enter warranty code"}
											focus={this.props.form.hasFocus(this.props.form.warrantyCode)}/>

						</Col>
						<Col lg={6} xl={6}>
							<InputFormGroup label={"Appliance short code"}
											field={this.props.form.applianceShortCode}
											onChange={this.props.onFieldChange}
											placeholder={"Enter appliance short code"}
											focus={this.props.form.hasFocus(this.props.form.applianceShortCode)}/>
						</Col>
					</Row>
					<Row>
						<Col xl={12} md={12}>
							<KeywordsFormGroup label={"Keywords"}
											   field={this.props.form.keywords}
											   onChange={this.props.onFieldChange}
											   placeholder={"Enter keywords"}
											   focus={this.props.form.hasFocus(this.props.form.keywords)}/>
						</Col>
					</Row>
					<Row>
						<Col xl={12} md={12}>
							<TextAreaFormGroup field={this.props.form.description}
											   onChange={this.props.onFieldChange}
											   label={"Asset description"}
											   placeholder={"Description will be displayed on mobile as specification"}
											   rows={5}/>
						</Col>
					</Row>
					<Row>
						<Col xl={6} md={6}>
							<TierLeverFormGroup field={this.props.form.tierLevel}
												onChange={this.props.onFieldChange}
												label={"Tier Level"}
												placeholder={"Select tier level"}/>
						</Col>
						<Col xl={6} md={6}>
							<RangeNumberInputFormGroup field={this.props.form.rewardsPoints}
													   onChange={this.props.onFieldChange}
													   label={"Rewards points"}
													   placeholder={"Enter rewards points"}
													   maxDecimalPlaces={0}/>
						</Col>
					</Row>
					<Row>
						<Col xl={12} md={12}>
							<PrimaryAndOtherFilesDropDown attachments={this.props.form.attachments.getOptionalValue()}
														  onAddOrUpdateFile={this.props.onAddOrUpdateFile}/>

						</Col>
					</Row>
					<Row>
						<Col xl={8} md={8}>
							<TextAreaFormGroup label="Alert note"
											   placeholder="Enter alert note"
											   field={this.props.form.alertNote}
											   onChange={this.props.onFieldChange}
											   rows={9}/>
						</Col>
					</Row>
					<Row>
						<Col xl={4} md={4}>
							<CheckboxFormGroup field={this.props.form.disabled}
											   onChange={this.props.onFieldChange}
											   label={"Disabled"}/>
						</Col>
					</Row>
				</div>
			</SectionView>
		);
	}
}
